<template>
  <div>
    <el-drawer
      :title="couponId ? '编辑优惠券' : '新增优惠券'"
      :visible.sync="dialogVisible"
      :append-to-body="false"
      custom-class="c-drawer"
      size="65%"
      @close="handleClose"
    >
      <div class="drawer-content">
        <el-form
          ref="couponFormRef"
          :model="couponInfo"
          :inline="true"
          :rules="couponInfoRules"
          v-loading="formLoading"
          label-width="120px"
        >
          <el-col :span="12">
            <el-form-item label="优惠券名称:" prop="title">
              <el-input v-model="couponInfo.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券类型:" prop="type">
              <el-select v-model="couponInfo.type" :disabled="true">
                <el-option
                  v-for="item in couponTypeOptions"
                  :key="item.paraValue"
                  :label="item.paraName"
                  :value="item.paraValue"
                  default-first-option
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期类型:" prop="validityType">
              <el-select v-model="couponInfo.validityType" :disabled="true">
                <el-option
                  v-for="item in couponValidityTypeOptions"
                  :key="item.paraValue"
                  :label="item.paraName"
                  :value="item.paraValue"
                ></el-option>
              </el-select>
              <div class="explain">
                固定时: 优惠券Code与当前有效期保持一致
                <br />
                领取后N天有效: 优惠券Code在领取后N天后有效
                <br />
                长期有效: 优惠券Code永久有效
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券面额:" prop="amount">
              <el-input-number
                v-model="couponInfo.amount"
                :precision="2"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                满减券: 订单金额满足最低消费，则为减免金额。
                <br />
                代金券: 直接为减免金额
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券折扣:">
              <el-input-number
                v-model="couponInfo.discount"
                :precision="2"
                :max="1"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                折扣券: 0.8=8折,计算方式: 订单总额*折扣 100*(1-0.8)
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="券折扣上限:">
              <el-input-number
                v-model="couponInfo.discountLimit"
                :precision="2"
                :min="-1"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                表示最多允许折扣多少,与`优惠券折扣`相关，如果不填或者小于等于零，则默认为无限制
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最低消费:">
              <el-input-number
                v-model="couponInfo.minCost"
                :precision="2"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                只有金额满足最低消费才能使用
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期天数:">
              <el-input-number
                v-model="couponInfo.fixedTerm"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                N天失效 = 领取时间+有效期天数
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券总量:">
              <el-input-number
                v-model="couponInfo.total"
                :min="-1"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                如果不填或者小于等于零，则默认为无限制
              </div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="有效期开始时间:" prop="startTime">
              <el-date-picker
                v-model="couponInfo.startTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="有效期结束时间:" prop="endTime">
              <!--只允许明天之后-->
              <el-date-picker
                v-model="couponInfo.endTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券状态:" prop="status">
              <el-select v-model="couponInfo.status">
                <el-option
                  v-for="item in couponStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="explain">
                将配合JOB进行启动与结束
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="优惠券规则:">
              <div id="editor" class="editor"></div>
            </el-form-item>
          </el-col>
        </el-form>
        <!--表单底部-->
        <div class="editFooter-seat"></div>
      </div>
      <!--操作-->
      <div class="editOpera-seat"></div>
      <div class="drawer-footer">
        <div class="operation">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlerSave">保存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { selectParameterInfoBusiness } from "@/api/api";
import { storeCouponInfo, storeCouponSave } from "@/api/store";
import E from "wangeditor";
export default {
  name: "couponEdit",
  components: {},
  data() {
    return {
      dialogVisible: false,
      formLoading: false,
      editor: undefined,
      couponId: undefined,
      couponInfo: {
        status: 0,
        type: 2,
        validityType: 2
      },
      couponInfoRules: {
        title: [{ required: true, message: "优惠券名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" }
        ],
        validityType: [
          { required: true, message: "请选择有效期类型", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择优惠券状态", trigger: "change" }
        ]
        // startTime: [
        //   { required: true, message: "请选择有效期开始时间", trigger: "blur" }
        // ],
        // endTime: [
        //   // 不允许与开始时间相同
        //   {
        //     validator: (rule, value, callback) => {
        //       if (
        //         value &&
        //         value.getTime() < this.couponInfo.startTime.getTime()
        //       ) {
        //         callback(new Error("结束时间必须大于开始时间"));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ]
      },
      couponStatusOptions: [
        {
          label: "未开始",
          value: 0
        },
        {
          label: "进行中",
          value: 1
        },
        {
          label: "已结束",
          value: 2
        }
      ],
      couponTypeOptions: [],
      couponValidityTypeOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  created() {
    this.getBizCouponTypeOptions();
    this.getBizCouponValidityTypeOptions();
  },
  watch: {},
  methods: {
    show(id) {
      this.couponId = id;
      this.dialogVisible = true;
      setTimeout(() => {
        this.createEditor();
      }, 300);
      if (id) {
        this.getCouponInfo();
      } else {
        const _init = {
          minCost: 0,
          total: -1,
          status: 0,
          maxFetch: 1
        };
        this.couponInfo = { ...this.couponInfo, _init };
        if (this.editor) {
          this.editor.txt.html("");
        }
      }
    },
    createEditor() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.editor = new E("#editor");
      console.log(this.editor);
      this.editor.config.zIndex = 0;
      this.editor.create();
      if (this.couponInfo.descriptionHtml) {
        this.editor.txt.html(this.couponInfo.descriptionHtml);
      } else {
        this.editor.txt.html("");
      }
    },
    getCouponInfo() {
      let _self = this;
      console.log(this.couponId);
      storeCouponInfo(this.couponId).then(res => {
        console.log(res);
        if (res.data.status == 100) {
          _self.setFormInfo(res.data.results);
        }
      });
    },
    setFormInfo(data) {
      this.couponInfo = data;
      if (this.editor) {
        this.editor.txt.html(data.descriptionHtml);
      }
    },
    getBizCouponTypeOptions() {
      let _self = this;
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "biz_coupon_type"
      }).then(resp => {
        if (resp.data.results) {
          _self.couponTypeOptions = resp.data.results.list.map(e => {
            e.paraValue = Number(e.paraValue);
            return e;
          });
        }
      });
    },
    getBizCouponValidityTypeOptions() {
      let _self = this;
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "biz_coupon_validity_type"
      }).then(resp => {
        if (resp.data.results) {
          _self.couponValidityTypeOptions = resp.data.results.list.map(e => {
            e.paraValue = Number(e.paraValue);
            return e;
          });
        }
      });
    },
    handlerSave() {
      this.$refs.couponFormRef.validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    getFormData() {
      const data = this.couponInfo;
      data.description = this.editor.txt.text();
      data.descriptionHtml = this.editor.txt.html();
      return data;
    },
    saveData() {
      let _self = this;
      const data = this.getFormData();
      this.formLoading = true;
      storeCouponSave(data)
        .then(res => {
          console.log(res);
          if (res.data.status == 100) {
            _self.$message({
              message: res.data.message,
              type: "success"
            });
            _self.handleClose();
            _self.$emit("success");
          } else {
            _self.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          _self.formLoading = false;
        });
    },
    handleClose() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.dialogVisible = false;
    }
  },
  beforeDestroy() {}
};
</script>
<style>
.c-drawer .el-drawer__body {
  overflow: auto;
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-all;
  overflow: auto;
}
</style>
<style lang="scss" scoped>
.c-drawer {
  .drawer-content {
    //距离bottom
    .editor {
      height: 300px;
      margin-bottom: 100px;
    }
    .explain {
      font-size: 12px;
      color: #999;
      margin-top: 8px;
      line-height: 1.5;
    }
  }
  .editOpera-seat {
    width: 100%;
    height: 54px;
  }
  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 30;
    display: flex;
    /** 操作 靠右 */
    .operation {
      margin-left: auto;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// couponEdit.vue?d658663c